import antd from 'ant-design-vue/es/locale-provider/vi_VN'
import momentCN from 'moment/locale/vi'
import setting from './vi/setting'

const components = {
  antLocale: antd,
  momentName: 'vi',
  momentLocale: momentCN
}

export default {
  'message': '-',

  ...components,
  ...setting
}
